import {Button, Modal} from "react-bootstrap";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {Input} from "../../../common/inputs/index.js";
import {useEdytujTag} from "../../../../api/domain/tagi/mutations/useEdytujTag.jsx";
import {useDodajTag} from "../../../../api/domain/tagi/mutations/useDodajTag.jsx";
import {useUsunTag} from "../../../../api/domain/tagi/mutations/useUsunTag.jsx";

export const ModalDodajEdytujTagi = ({currPozycja, show, handleClose}) => {
    const zmien = useEdytujTag()
    const dodaj = useDodajTag()

    const func = currPozycja ? zmien : dodaj;


    const [form, setForm] = useState({
            id: currPozycja?.id,
            nazwa: currPozycja?.nazwa
        }
    )

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
    }

    const handleOnClose = () => {
        handleClose()
    }

    useEffect(() => {
        setForm({
            id: currPozycja?.id,
            nazwa: currPozycja?.nazwa
        })

    }, [currPozycja])

    return <Modal size={'lg'} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Dodawanie/Edytowanie tagu: </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Input
                label={'Nazwa tagu'}
                value={form.nazwa}
                onChange={(e) => setField('nazwa', e.target.value)}
                placeholder={'Nazwa tagu'}
            /> </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleOnClose}>
                Anuluj
            </Button>
            <Button variant="success" onClick={() => {
                func.mutate(form)
                handleOnClose();
            }}>
                Zapisz zmiany
            </Button>
        </Modal.Footer>
    </Modal>
}

ModalDodajEdytujTagi.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func
}


export const ModalUsunTag = ({currPozycja, show, handleClose}) => {

    const usun = useUsunTag()

    const handleOnClose = () => {
        handleClose()
    }

    return <Modal size={'lg'} show={show} onHide={handleOnClose}>
        <Modal.Header closeButton>
            <Modal.Title>Usuwanie tagu: </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Czy na pewno chcesz usunąć tag: <strong>{currPozycja?.nazwa}</strong>?
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleOnClose}>
                Anuluj
            </Button>
            <Button variant="danger" onClick={() => {
                usun.mutate({id: currPozycja.id})
                handleOnClose();
            }}>
                Usuń
            </Button>
        </Modal.Footer>
    </Modal>

}

ModalUsunTag.propTypes = {
    currPozycja: PropTypes.object,
    show: PropTypes.bool,
    handleClose: PropTypes.func
}